/**
 * @function mouseButtons
 * @description 마우스 이벤트 객체내, 마우스 버튼 입력 정보를 WC3 HTML5 표준에서 지정한 값으로 정규화 함
 * @ref @see https://github.com/mikolalysenko/mouse-event
 * @param {*} event 마우스 이벤트 발생시 전달받는 이벤트 객체
 * @returns
 */
function mouseButtons(event) {
  if (typeof event === "object") {
    var b = 0;
    if ("buttons" in event) {
      return event.buttons;
    } else if ("which" in event) {
      b = event.which;
      if (b === 2) {
        return 4;
      } else if (b === 3) {
        return 2;
      } else if (b > 0) {
        return 1 << (b - 1);
      }
    } else if ("button" in event) {
      b = event.button;
      if (b === 1) {
        return 4;
      } else if (b === 2) {
        return 2;
      } else if (b >= 0) {
        return 1 << b;
      }
    }
  }
  return 0;
}

/**
 * @function mouseElement
 * @description 마우스 이벤트 객체내, 이벤트 발생 Element 반환 (Cross-Browsing 지원)
 * @ref @see https://github.com/mikolalysenko/mouse-event
 * @param {*} event 마우스 이벤트 발생시 전달받는 이벤트 객체
 * @returns
 */
function mouseElement(event) {
  return event.target || event.srcElement || window;
}

/**
 * @function mouseRelativeX
 * @description 마우스 이벤트 객체내, offsetX 값 정규화 (Cross-Browsing 지원)
 * @ref @see https://github.com/mikolalysenko/mouse-event
 * @param {*} event 마우스 이벤트 발생시 전달받는 이벤트 객체
 * @returns
 */
function mouseRelativeX(event) {
  if (typeof event === "object") {
    if ("offsetX" in event) {
      return event.offsetX;
    }
    var target = mouseElement(event);
    var bounds = target.getBoundingClientRect();
    return event.clientX - bounds.left;
  }
  return 0;
}

/**
 * @function mouseRelativeY
 * @description 마우스 이벤트 객체내, offsetY 값 정규화 (Cross-Browsing 지원)
 * @ref @see https://github.com/mikolalysenko/mouse-event
 * @param {*} event 마우스 이벤트 발생시 전달받는 이벤트 객체
 * @returns
 */
function mouseRelativeY(event) {
  if (typeof event === "object") {
    if ("offsetY" in event) {
      return event.offsetY;
    }
    var target = mouseElement(event);
    var bounds = target.getBoundingClientRect();
    return event.clientY - bounds.top;
  }
  return 0;
}

function checkIsMouseOver(event, element) {
  if (
    event.clientX >= element.left &&
    event.clientX <= element.right &&
    event.clientY >= element.top &&
    event.clientY <= element.bottom
  ) {
    // Mouse is inside element.
    return true;
  }
  return false;
}

const NormalizeMouseEvent = {
  x: mouseRelativeX,
  y: mouseRelativeY,
  element: mouseElement,
  buttons: mouseButtons,
  checkIsMouseOver
};

export default NormalizeMouseEvent;
